module.exports = __webpack_public_path__ + "img/DSC_0679.50b39fe4.jpeg";